import React, { useEffect, useState } from "react";
import PageTitle from "../../../Module/pageTitle";
import { useDispatch } from "react-redux";
import {
  addShotVideo,
  getExamListNew,
  getParentCourseNew,
  getStoryTypeList,
  uploadFileShort,
} from "../../../Action/courseAction";
import AddMorebtn from "../../../Component/addMoreBtn";
import LabelField from "../../../Component/labelField";
import CustomDropdown from "../../../Component/customDropdown";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import {
  containSpace,
  pdf_size_1MB,
  validateIsFileImageType,
} from "../../../Utils/validators";
import { showErrorSnackbar } from "../../../Action/snackbarAction";
import { validateIsFileImageTypeErrMsg } from "../../../Utils/errorMsg";
import ImagePickerAndViewer from "../../../Component/imagePickerAndViewer";
import uploadVideo from "../../../Images/upload-video.png";
import uploadedVideo from "../../../Images/uploaded-video.png";
import { getSubExam } from "../../../Action/adminPanelAction";
import SquareCheckBox from "../../../Component/SquareCheckBox";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import FormInputField from "../../../Component/FormInputField";
import Dropdown from "../../../Component/dropdown";

const CreateExamSrcVideo = () => {
  const dispatch = useDispatch();
  //video check
  const [uploadText, setUploadText] = useState("");
  const [file, setFile] = useState(null);
  const [resetExam, setResetExam] = useState(false);
  const [resetSubExam, setResetSubExam] = useState(false);
  const [resetParentCourse, setResetParentCourse] = useState(false);
  const initialVal = [
    {
      btnType: "",
      btnName: "",
      btnUrl: "",
    },
  ];
  const [createBtn, setCreateBtn] = useState(initialVal);
  //end
  const initalValExam = {
    examName: "",
    subExamName: "",
    parentCourseVal: "",
    subExamList: [],
    parentCourseList: [],
    resetExamName: false,
    resetSubExamName: false,
    resetParentCourse: false,
  };
  const uploadOptn = [
    { _id: 1, name: "Image" },
    { _id: 2, name: "Video" },
  ];
  const urlOptions = [
    { _id: 1, name: "PDF" },
    { _id: 2, name: "Explore Course" },
    { _id: 3, name: "Watch Video" },
    { _id: 4, name: "Resource Pages" },
  ];
  const [examData, setExamData] = useState([initalValExam]);
  const [examList, setExamList] = useState([]);
  const [uploadType, setUploadType] = useState("");
  const [resetUploadType, setResetUploadType] = useState(false);
  const [packageBanner, setPackageBanner] = useState("");
  const [imageData, setImageData] = useState(null);
  const [videoData, setVideoData] = useState(null);
  const [selectedExamList, setSelectedExamList] = useState([]);
  const [allSelectedExamList, setAllSelectedExamList] = useState([]);
  const [exam, setExam] = useState("");
  const [urlType, setUrlType] = useState("");
  const [urlTypeLink, setUrlTypeLink] = useState("");
  const [resetUrlType, setResetUrlType] = useState(false);
  const [storyTypeList, setStoryTypeList] = useState([]);
  const [storyType, setStoryType] = useState("");
  const [resetStoryType, setResetStoryType] = useState(false);

  const onListChange = async (value, index) => {
    let newArray = JSON.parse(JSON.stringify(examData));
    newArray[index].examName = value;
    newArray[index].parentCourseVal = "";
    newArray[index].subExamName = "";
    newArray[index].subExamList = [];
    newArray[index].parentCourseList = [];
    newArray[index].resetExamName = false;
    newArray[index].resetParentCourse = true;
    newArray[index].resetSubExamName = true;
    await dispatch(
      getSubExam(
        {
          examTypeId: exam._id,
        },
        (res) => {
          if (res.data.length !== 0) {
            newArray[index].subExamList = res.data;
          } else {
            dispatch(
              getParentCourseNew(`${value._id}`, (res) => {
                newArray[index].parentCourseList = res;
              })
            );
          }
        }
      )
    );
    await setExamData(newArray);
  };
  const onSubExamChange = async (value, index) => {
    let newArray = JSON.parse(JSON.stringify(examData));
    newArray[index].subExamName = value;
    newArray[index].resetSubExamName = false;
    newArray[index].parentCourseVal = "";
    newArray[index].parentCourseList = [];
    newArray[index].resetParentCourse = true;
    await dispatch(
      getParentCourseNew(
        `${examData[index].examName._id}/${value._id}`,
        (res) => {
          newArray[index].parentCourseList = res;
        }
      )
    );
    await setExamData(newArray);
  };
  const changeParentCourseVal = async (value, index) => {
    let newArray = JSON.parse(JSON.stringify(examData));
    newArray[index].parentCourseVal = value;
    newArray[index].resetParentCourse = false;
    await setExamData(newArray);
  };
  const handleCloseExam = (index) => {
    const newArray = [...examData];
    if (index > -1) {
      newArray.splice(index, 1);
    }
    setExamData(newArray);
  };
  const handleLogoChange = (e) => {
    e.preventDefault();
    const reader = new FileReader();
    const file = e.target.files[0];
    if (!validateIsFileImageType(e)) {
      dispatch(showErrorSnackbar(validateIsFileImageTypeErrMsg));
      return;
    } else if (file.size > pdf_size_1MB) {
      dispatch(showErrorSnackbar("File size should be less than 1 MB!!!"));
    } else {
      reader.onloadend = () => {
        setPackageBanner(reader.result);
      };
      dispatch(
        uploadFileShort(file, async (resp) => {
          setImageData(resp);
        })
      );
      reader.readAsDataURL(file);
    }
  };
  const handleUploadType = (value) => {
    setUploadType(value);
    if (value?.name === "Image") {
      setVideoData(null);
    } else {
      setImageData(null);
    }
  };

  useEffect(() => {
    dispatch(
      getStoryTypeList((res) => {
        setStoryTypeList(res);
      })
    );
  }, []);

  const handleStoryType = (value) => {
    setStoryType(value);
  };

  const handleURLType = (value) => {
    setUrlType(value);
    setUrlTypeLink("");
  };

  const onChangeUrlLink = (value) => {
    if (containSpace(value)) {
      dispatch(showErrorSnackbar("Space Not Allowed"));
    } else setUrlTypeLink(value);
  };

  const onSelectExam = (event, index) => {
    let newArray = JSON.parse(JSON.stringify(examList));
    newArray[index]["isSelected"] = event.target.checked;
    if (Array.isArray(newArray[index].baseCourseId)) {
      newArray[index].baseCourseId = newArray[index].baseCourseId.map(
        (baseCourse) => ({
          ...baseCourse,
          isSelected: event.target.checked,
        })
      );
    }
    setExamList(newArray);
    setExam(newArray);
    const selectedExamIds = newArray
      .filter((exam) => exam.isSelected === true)
      .map((exam) => exam._id);

    setSelectedExamList(selectedExamIds);
    const allSelected = newArray.reduce((acc, ex) => {
      ex.baseCourseId?.forEach((bc) => {
        if (bc.isSelected) {
          acc.push({
            examId: ex._id,
            examName: ex.name,
            baseCourseId: bc._id,
            baseCourseName: bc.name,
          });
        }
      });
      return acc;
    }, []);

    setAllSelectedExamList(allSelected);
  };

  const onChangeExam = (value) => {
    setExam(value);
  };
  const onSelectExamStream = (event, index, exam) => {
    let newArray = [...examList];

    const examIndex = newArray.findIndex((item) => item._id === exam._id);

    if (examIndex !== -1) {
      const updatedExam = { ...newArray[examIndex] };

      if (updatedExam.baseCourseId && updatedExam.baseCourseId[index]) {
        updatedExam.baseCourseId[index] = {
          ...updatedExam.baseCourseId[index],
          isSelected: event.target.checked,
        };

        const selectedBaseCourses = updatedExam.baseCourseId.filter(
          (item) => item.isSelected === true
        );

        const selectedData = selectedBaseCourses.map((bc) => ({
          examId: updatedExam._id,
          examName: updatedExam.name,
          baseCourseId: bc._id,
          baseCourseName: bc.name,
        }));

        const isAnyBaseCourseSelected = selectedBaseCourses.length > 0;

        updatedExam.isSelected = isAnyBaseCourseSelected;

        const allSelected = newArray.reduce((acc, ex) => {
          ex.baseCourseId?.forEach((bc) => {
            if (bc.isSelected) {
              acc.push({
                examId: ex._id,
                examName: ex.name,
                baseCourseId: bc._id,
                baseCourseName: bc.name,
              });
            }
          });
          return acc;
        }, []);

        setAllSelectedExamList(allSelected);
      }

      newArray[examIndex] = updatedExam;
    }

    setExamList(newArray);
  };
  const onPressAdd = () => {
    setCreateBtn((prev) => {
      if (prev.length >= 2) return prev;

      return [...prev, { btnType: "", btnName: "", btnUrl: "" }];
    });
  };

  const handleClose = (index) => {
    const newArray = [...createBtn];
    if (index > -1) {
      newArray.splice(index, 1);
    }
    setCreateBtn(newArray);
  };

  const handleButtonChange = (value, field, index) => {
    setCreateBtn((prev) => {
      const updated = [...prev];
      if (field === "btnUrl") {
        value = value?.replace(/\s+/g, "");
      }
      if (field === "btnType" && typeof value === "object") {
        updated[index][field] = value;
      } else {
        updated[index][field] = value;
      }
      return updated;
    });
  };

  const renderExamSet = () => {
    return (
      <div className="col-12">
        <div className="col-auto">
          <div className="d-flex mb-2 align-items-center col-6">
            <LabelField labelName={"Story Type"} isRequired />
            <CustomDropdown
              setInputText={(value) => handleStoryType(value)}
              defaultValue={storyType?._id}
              options={storyTypeList}
              reset={resetStoryType}
              labelName="Select Story Type"
            />
          </div>
          {renderParentExamSubExam()}
          <div className="d-flex mb-2 align-items-center col-6">
            <LabelField labelName={"Upload Type"} isRequired />
            <CustomDropdown
              setInputText={(value) => handleUploadType(value)}
              defaultValue={uploadType?._id}
              options={uploadOptn}
              reset={resetUploadType}
              labelName="Select Upload Type"
            />
          </div>
          {uploadType?.name === "Image" && (
            <div className="d-flex mb-2 align-items-center col-6">
              <ImagePickerAndViewer
                labelName={"Upload Image"}
                value={packageBanner}
                handleChange={(e) => handleLogoChange(e)}
                htmlFor={"photo-upload"}
                isRequired
              />
            </div>
          )}
          {uploadType?.name === "Video" && (
            <>
              <div className="d-flex align-items-center me-3 mb-4 col-6">
                <LabelField labelName={"Upload Video"} isRequired />
                <label htmlFor="upVideo" className="form-label cursor">
                  {uploadText ? (
                    <img src={uploadedVideo} alt="upload-vidoe" width="80" />
                  ) : (
                    <img src={uploadVideo} alt="upload-vidoe" />
                  )}
                  <span className="d-block uvName">
                    {file ? <span>{file.name}</span> : "Upload Video"}
                  </span>
                </label>
                <input
                  className="form-control d-none"
                  type="file"
                  id="upVideo"
                  accept="video/*,.mkv"
                  onChange={(e) => {
                    setFile(e.target.files[0]);
                    const file = e.target.files[0];
                    if (file) {
                      const video = document.createElement("video");
                      video.preload = "metadata";
                      video.onloadedmetadata = () => {
                        window.URL.revokeObjectURL(video.src);
                      };
                      video.src = URL.createObjectURL(file);
                      dispatch(
                        uploadFileShort(file, async (resp) => {
                          setVideoData(resp);
                        })
                      );
                    }
                  }}
                />
              </div>
            </>
          )}
          <div className="col-md-6">
            {createBtn?.map((item, index) => {
              const selectedValues = createBtn
                ?.map((btn, i) => (i !== index ? btn.btnType?._id : null))
                ?.filter(Boolean);
              const filteredOptions = urlOptions.filter(
                (opt) => !selectedValues.includes(opt._id)
              );

              return (
                <div
                  key={index}
                  className="position-relative border border-1 rounded-1 p-2 mb-2"
                >
                  <span className="d-flex justify-content-end p-2 removeButton">
                    {createBtn?.length === 1 ? null : (
                      <HighlightOffIcon
                        className="cursor"
                        color="primary"
                        fontSize="small"
                        onClick={() => handleClose(index)}
                      />
                    )}
                  </span>
                  <div className="d-flex mb-2 align-items-center">
                    <LabelField labelName={"Button Type"} />
                    <Dropdown
                      setInputText={(value) =>
                        handleButtonChange(value, "btnType", index)
                      }
                      value={item?.btnType}
                      options={filteredOptions}
                      reset={resetUrlType}
                      labelName="Select Button Type"
                    />
                  </div>
                  {item.btnType && (
                    <>
                      <div className="d-flex mb-2 align-items-center">
                        <LabelField labelName={"Button Link"} />
                        <FormInputField
                          placeholder={"Enter Button Link"}
                          setInputText={(value) =>
                            handleButtonChange(value, "btnUrl", index)
                          }
                          value={item.btnUrl}
                        />
                      </div>
                      <div className="d-flex mb-2 align-items-center">
                        <LabelField labelName={"Button Name"} />
                        <FormInputField
                          placeholder={"Enter Button Name"}
                          setInputText={(value) =>
                            handleButtonChange(value, "btnName", index)
                          }
                          value={item.btnName}
                        />
                      </div>
                    </>
                  )}
                </div>
              );
            })}
          </div>
          <div className="my-2 col-md-6 d-flex justify-content-end">
            {createBtn?.length < 2 && (
              <AddMorebtn
                handleClick={onPressAdd}
                className={`btn mb-3 submitbtn ${
                  validateButtons() ? "btn-secondary" : "btn-primary"
                }`}
                disabled={createBtn?.length >= 2}
              />
            )}
          </div>
        </div>

        <div className="col-auto d-flex justify-content-center">
          <div className="col-auto d-flex justify-content-center mt-4">
            <button
              type="submit"
              className={`btn mb-3 submitbtn ${
                validations() ? "btn-secondary" : "btn-primary"
              }`}
              disabled={validations()}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    );
  };
  // const renderParentExamSubExam = () => {
  //   return (
  //     <>
  //       {examData?.map((item, index) => {
  //         const {
  //           parentCourseVal,
  //           examName,
  //           subExamName,
  //           parentCourseList,
  //           subExamList,
  //         } = item;
  //         return (
  //           <>
  //             <div className="position-relative py-3 mb-3 d-flex align-items-start justify-content-start">
  //               <div className="d-flex mb-2 align-items-start">
  //                 <LabelField labelName={"Exam Name"} />
  //                 <CustomDropdown
  //                   setInputText={(value) => onListChange(value, index)}
  //                   defaultValue={examName._id}
  //                   options={examList}
  //                   Isrequired={true}
  //                   reset={resetExam}
  //                   labelName="Select Exam Name"
  //                 />
  //                 <span className="d-flex justify-content-end p-2 removeButton">
  //                   {examData?.length === 1 ? null : (
  //                     <HighlightOffIcon
  //                       className="cursor"
  //                       color="primary"
  //                       fontSize="small"
  //                       onClick={() => handleCloseExam(index)}
  //                     />
  //                   )}
  //                 </span>
  //               </div>
  //               {subExamList?.length > 0 ? (
  //                 <div className="d-flex mb-2 align-items-center">
  //                   <LabelField labelName={"Sub Exam Name"} />
  //                   <CustomDropdown
  //                     setInputText={(value) => onSubExamChange(value, index)}
  //                     defaultValue={subExamName._id}
  //                     Isrequired={true}
  //                     options={subExamList}
  //                     reset={resetSubExam}
  //                     labelName="Select Sub Exam Name"
  //                   />
  //                 </div>
  //               ) : null}
  //               <div className="d-flex mb-2 align-items-start">
  //                 <LabelField labelName={"Exam Stream"} />
  //                 <CustomDropdown
  //                   setInputText={(value) =>
  //                     changeParentCourseVal(value, index)
  //                   }
  //                   defaultValue={parentCourseVal._id}
  //                   options={parentCourseList}
  //                   labelName="Select Exam Stream"
  //                   Isrequired={true}
  //                   reset={resetParentCourse}
  //                 />
  //               </div>
  //             </div>
  //           </>
  //         );
  //       })}
  //       <div className="d-flex justify-content-end">
  //         <AddMorebtn
  //           style={{
  //             width: "99px",
  //             height: "39px",
  //             marginTop: "22px",
  //           }}
  //           handleClick={() => setExamData([...examData, initalValExam])}
  //         />
  //       </div>
  //     </>
  //   );
  // };

  const renderParentExamSubExam = () => {
    return (
      <>
        <div className="position-relative py-3 mb-3 d-flex align-items-start justify-content-start">
          <div className="d-flex mb-2 align-items-start">
            <LabelField labelName={"Exam Name"} isRequired />
            {examList?.length > 0 ? (
              <div className="d-flex align-items-start">
                <div className="border border-1 rounded-2 w-100">
                  {examList.map((c, index) => {
                    return (
                      <div
                        className="d-flex font-12 align-items-center border-bottom py-1 px-2 mb-1"
                        key={index}
                      >
                        <SquareCheckBox
                          id={c?._id}
                          type="checkbox"
                          name={"Exam Name"}
                          value={c?.name}
                          checked={c?.isSelected}
                          onChange={(event) => {
                            onSelectExam(event, index);
                          }}
                          // labelName={c?.name}
                        />
                        <div
                          className="d-flex justify-content-between align-items-center cursor w-100  "
                          onClick={() => onChangeExam(c)}
                        >
                          <div
                            className={`${
                              c?._id === exam?._id ? "fw-bold text-primary" : ""
                            }`}
                          >
                            {c?.name}
                          </div>
                          <div className="ms-2">
                            {c?._id === exam?._id ? (
                              <RemoveRedEyeIcon className="font18 text-primary" />
                            ) : (
                              <RemoveRedEyeIcon style={{ fontSize: "18px" }} />
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : null}
          </div>
          {exam?.baseCourseId?.length > 0 ? (
            <div className="d-flex mb-2 align-items-start ms-4">
              <LabelField labelName={"Exam Stream"} />
              <div className="w-100 border border-1 rounded-2">
                <div>
                  {exam?.baseCourseId?.map((c, index) => {
                    return (
                      <div
                        className="d-flex align-items-center border-bottom py-1 px-2 mb-1"
                        key={index}
                      >
                        <SquareCheckBox
                          id={c._id}
                          name={"Exam Stream"}
                          value={c.name}
                          checked={c.isSelected}
                          onChange={(event) => {
                            onSelectExamStream(event, index, exam);
                          }}
                          labelName={c.name}
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
          ) : null}
        </div>
      </>
    );
  };
  // const validateArr = () => {
  //   let result = false;
  //   for (let i = 0; i < examList?.length; i++) {
  //     if (examList[i]?.examName === "" || examList[i]?.parentCourseVal === "") {
  //       result = true;
  //     }
  //   }
  //   return result;
  // };
  const validateArr = () => {
    return allSelectedExamList?.some(
      (exam) => !exam?.examName || !exam?.baseCourseName
    );
  };
  const validateButtons = () => {
    for (let i = 0; i < createBtn.length; i++) {
      const item = createBtn[i];

      if (!item.btnType || item.btnType === "" || !item.btnType?._id) {
        continue;
      }

      if (!item.btnUrl || item.btnUrl?.trim() === "") {
        return false;
      }

      if (!item.btnName || item.btnName?.trim() === "") {
        return false;
      }
    }

    return true;
  };

  const validations = () => {
    return (
      allSelectedExamList.length === 0 ||
      storyType === "" ||
      uploadType === "" ||
      (uploadType?.name === "Image" && !packageBanner) ||
      (uploadType?.name === "Video" && !file) ||
      (urlType !== "" && !urlTypeLink) ||
      !validateButtons()
    );
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    // let newArr = JSON.parse(JSON.stringify(examData));
    // let arr1 = newArr.map((item) => {
    //   if (item?.subExamName) {
    //     return {
    //       examTypeId: item?.examName?._id,
    //       subExamTypeId: item?.subExamName?._id,
    //       baseCourseId: item?.parentCourseVal?._id,
    //     };
    //   } else {
    //     return {
    //       examTypeId: item?.examName?._id,
    //       baseCourseId: item?.parentCourseVal?._id,
    //     };
    //   }
    // });
    let arraySelectedExam = allSelectedExamList.map((item) => {
      return {
        examTypeId: item?.examId,
        baseCourseId: item?.baseCourseId,
      };
    });
    const validArray = createBtn.filter(
      (item) => item.btnType?._id && item.btnName?.trim() && item.btnUrl?.trim()
    );
    let reqBody = {
      uploadtype: uploadType?._id,
      exams: arraySelectedExam,
      videoCategory: storyType?._id,
      button: validArray?.map((item) => ({
        text: item.btnName,
        url: item.btnUrl,
        urlType: item.btnType?._id,
      })),
    };
    if (imageData !== null) {
      reqBody.uploadurl = imageData?.fileUrl;
    } else if (videoData !== null) {
      reqBody.uploadurl = videoData?.fileUrl;
    }
    dispatch(
      addShotVideo(reqBody, async () => {
        setResetExam(true);
        setResetSubExam(true);
        setResetParentCourse(true);
        setExamData([initalValExam]);
        setCreateBtn([initialVal]);
        setUploadType("");
        setResetUploadType(true);
        setPackageBanner("");
        setImageData(null);
        setVideoData(null);
        setSelectedExamList([]);
        setAllSelectedExamList([]);
        setExam("");
        setUrlType("");
        setResetUrlType(true);
        setUrlTypeLink("");
        setStoryType("");
        setResetStoryType(true);
      })
    );
  };
  useEffect(() => {
    setUploadText(false);
    dispatch(
      getExamListNew((res) => {
        let tempExam = res?.map((item) => {
          let tempExamStream = item?.baseCourseId?.map((subItem) => {
            return {
              _id: subItem?._id,
              name: subItem?.name,
              isSelected: false,
            };
          });
          return {
            _id: item?._id,
            name: item?.name,
            baseCourseId: tempExamStream,
            isSelected: false,
          };
        });
        setExamList(tempExam);
      })
    );
    // setExamList(res);
    setSelectedExamList([]);
    setAllSelectedExamList([]);
  }, []);
  return (
    <div className="contentBox">
      <PageTitle name={"ADD EXAM SHORTS VIDEO"} />
      <div className="row formDiv m-0">
        <div className="col-12 formDiv d-flex ">
          <form className="formWidth col-12" onSubmit={handleSubmit}>
            {renderExamSet()}
          </form>
        </div>
      </div>
    </div>
  );
};

export default CreateExamSrcVideo;
